import React from 'react';
import PropTypes from 'prop-types';
import { Map } from 'immutable';
import styled from 'styled-components';
import { APP_URL } from '../env';
import { seedOf } from '../random';
import TrainerAvatar from './TrainerAvatar';

const Circle = styled.span`
  flex: none;
  display: inline-grid;
  place-items: center;
  width: ${({ $size }) => $size}px;
  height: ${({ $size }) => $size}px;
  border-radius: 50%;
  overflow: hidden;
  background: #2b5f8a;
  color: #f4f1e8;
  font-size: ${({ $size }) => Math.round($size * 0.42)}px;
  font-weight: 700;
  vertical-align: middle;

  & img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

/** The first letters of someone's name, for when they have no picture. */
export const initials = (name) => {
  const letters = (name || '').split(/\s+/).map(word => word.replace(/[^\p{L}\p{N}]/gu, '')).filter(Boolean);
  return letters.length ? letters.slice(0, 2).map(word => word[0].toUpperCase()).join('') : '?';
};

/** What's in the circle: a picture (a person's, or a computer level's), a drawn trainer, or initials. */
function face(user, game) {
  if (user && user.get('avatar')) {
    return <img src={`${APP_URL}${user.get('avatar')}`} alt="" />;
  }
  // A computer level without a picture of its own.
  if (user && user.get('computer')) {
    return <TrainerAvatar seed={seedOf(`trainer-${user.get('id')}-${game ?? ''}`)} />;
  }
  return initials(user && user.get('name'));
}

/**
 * Someone's profile picture (the server's `avatar` address), or their initials in a circle when they have none. A
 * computer level has a picture of its own; one without is a cartoon trainer, a different one in each game (`game`).
 */
const Avatar = ({ user, size, game }) => (
  <Circle $size={size} aria-hidden="true">
    {face(user, game)}
  </Circle>
);

Avatar.propTypes = {
  user: PropTypes.instanceOf(Map),
  size: PropTypes.number,
  /** The game it's shown for: which trainer a computer opponent is. */
  game: PropTypes.number,
};

Avatar.defaultProps = {
  size: 28,
};

export default Avatar;
